import React from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./batchForm.data.form";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  InputText,
  InputCheck,
  BreadCrumb,
  InputSelect,
  InputDate,
} from "@de-prado-dev/react-component-library";

const BatchForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, onback, edit, providers } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.batch.title"), path: PATHS.BATCH_LIST },
    { label: t("forms.batch.new") },
  ];

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">
            {edit ? t("forms.batch.titleEdit") : t("forms.batch.titleNew")}
          </h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-5">
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-12">
                <Field
                  id="code"
                  className="form-control"
                  labelField={t("forms.batch.labels.code")}
                  name="code"
                  placeholder=""
                  component={InputText}
                  fieldType="text"
                  mandatory
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <Field
                  id="active"
                  labelField={t("forms.batch.labels.active")}
                  name="active"
                  placeholder=""
                  component={InputCheck}
                  mandatory
                />
              </div>
            </div>
            {providers && providers.length > 0 && (
              <div className="row mt-3">
                <div className="col-12">
                  <Field
                    id="providerUuid"
                    labelField={t("forms.batch.labels.provider")}
                    name="providerUuid"
                    placeholder=""
                    component={InputSelect}
                    optionLabel="label"
                    optionValue="code"
                    options={providers.map((item) => ({
                      ...item,
                      label: t(item.name),
                      code: item.uuid,
                    }))}
                    addOptionEmpty
                    classNamePrefix="dark"
                    mandatory
                  />
                </div>
              </div>
            )}
            <div className="row mt-3">
              <div className="col-12">
                <Field
                  id="datePlanting"
                  className="form-control"
                  labelField={t("forms.batch.labels.datePlanting")}
                  name="datePlanting"
                  placeholder=""
                  component={InputDate}
                  language="es"
                  dateFormat="dd/MM/yyyy"
                />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => onback()}
                  className="btn btn-lg btn-primary me-2"
                >
                  {t("forms.batch.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-secondary">
                  {t("forms.batch.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

BatchForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onback: PropTypes.func,
  edit: PropTypes.bool,
};

const BatchFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "BatchForm",
})(BatchForm);

export default BatchFormF;
